/**
 * The current academic year, as this system writes it.
 *
 * ⚠ ONE COPY, AND IT IS NOW THE ONLY ONE ON THIS SIDE. This note used to end by saying the two
 * disagreeing modules had been left alone because fixing them was "a data decision with a migration
 * attached, not a refactor". That decision has since been taken and that migration has been run.
 *
 * What was actually wrong: eight versions of this function, six on the server and two here.
 *
 *     June boundary,  "2026-2027"   the SESSION — store, fee analytics, labs, rollups, fees
 *     April boundary, "2026-27"     the TAX YEAR — which Library and Hostel were using by mistake
 *
 * Those two were never a third opinion about the academic year. They were computing the FINANCIAL
 * year, calling it the academic year, and writing it into the same column the fee ledger uses —
 * which made every library fine and hostel charge invisible to a collection report filtering on
 * "2026-2027".
 *
 * The server now holds both rules side by side in Eduvora.Domain.Calendar.Years, named for what
 * they each are, and the stored rows have been normalised. This file is the SESSION, matching
 * AcademicYear.Of exactly: same boundary, same four-digit shape.
 *
 * ⚠ IT IS STILL A SECOND COPY OF A RULE, and the only honest defence is that the browser needs an
 * answer without a round trip. If the boundary ever becomes per-institution — a degree college does
 * not start in June — this function has to start asking the server rather than knowing.
 */
export function currentAcademicYear(now: Date = new Date()): string {
  // getMonth() is zero-based: 5 is June.
  return now.getMonth() >= 5
    ? `${now.getFullYear()}-${now.getFullYear() + 1}`
    : `${now.getFullYear() - 1}-${now.getFullYear()}`;
}
